import { useEffect, useRef } from "react";

export default function MaiaSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".maia-item").forEach((item, i) => {
              setTimeout(() => item.classList.add("maia-visible"), i * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="maia" className="py-16 lg:py-20 bg-[#FAFAFA] overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Video */}
          <div className="maia-item opacity-0 translate-x-[-24px] transition-all duration-700 relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden bg-black">
              <video
                className="w-full h-[320px] md:h-[420px] lg:h-[480px] object-cover"
                controls
                preload="metadata"
                playsInline
              >
                <source
                  src="https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/00f33962-f24e-4e66-b773-bd4311a4215a_Luz-Atualizado.mp4"
                  type="video/mp4"
                />
                Seu navegador não suporta o elemento de vídeo.
              </video>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-2xl border-2 border-[#FBC52D]/20 -z-10" />
            <div className="absolute -top-4 -right-4 w-16 h-16 rounded-xl bg-[#FBC52D]/10 -z-10" />
          </div>

          {/* Right: Content */}
          <div className="maia-item opacity-0 translate-x-6 transition-all duration-700 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-8 h-px bg-black" />
              <span className="text-black text-lg font-semibold tracking-widest uppercase">
                INTELIGÊNCIA ARTIFICIAL
              </span>
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black leading-tight mb-4">
              Conheça a Luz
              <br />
              <span className="text-[#FBC52D]">Assistente virtual da Ferrarezi</span>
            </h2>

            <p className="text-black/70 text-base leading-relaxed mb-5">
              A Luz é nossa assistente com IA de ponta, disponível 24/7 para tirar dúvidas sobre planos de saúde, odontológicos, seguros e benefícios. Reduz filas, desafoga o RH e entrega respostas instantâneas com atendimento humanizado.
            </p>

            {/* Features list */}
            <div className="grid grid-cols-2 gap-3 mb-6">
              {[
                { icon: "ri-message-3-line", label: "Atendimento 24/7" },
                { icon: "ri-brain-line", label: "IA treinada em benefícios" },
                { icon: "ri-flashlight-line", label: "Respostas instantâneas" },
                { icon: "ri-heart-pulse-line", label: "Saúde e bem-estar" },
              ].map((feat) => (
                <div key={feat.label} className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#FBC52D]/10 shrink-0">
                    <i className={`${feat.icon} text-[#FBC52D] text-sm`} />
                  </div>
                  <span className="text-black/80 text-xs font-medium">{feat.label}</span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="w-full">
              <button
                onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
                className="whitespace-nowrap bg-[#FBC52D] text-black font-bold px-6 py-3 rounded-full hover:bg-[#d4a800] transition-all duration-200 cursor-pointer text-sm w-full"
              >
                Quero conhecer a Luz
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .maia-visible {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }
      `}</style>
    </section>
  );
}